// extracted by mini-css-extract-plugin
export default {"container":"UserFromPassword_container__ti3u6","error":"UserFromPassword_error__hFKYP"};